module.exports = __webpack_public_path__ + "media/src/images/icon__magazinCheck-a2483ba0f2503e2d9f93308d0483b1e4.svg";